class TerminalPayment implements MerchantosRegisterTerminalPayment {
  /**
   * Helper method to return a jQuery object for the credit card terminal payments container
   *
   * @returns {jQuery}    The credit card terminal payments container
   * @private
   */
  private getTerminalPaymentElement = () => {
    return $('#credit_card_terminal_payments');
  };

  /**
   * Event handler for when a terminal is slected from the list of terminals
   * in the terminal dropdown.
   *
   * @param terminalId {Number} The terminal ID.
   * @param isRefund {Boolean}  True when we're refunding an ammount
   * @private
   */
  public onTerminalSelected: MerchantosRegisterTerminalPayment['onTerminalSelected'] = (
    terminalName,
    isRefund
  ) => {
    const $terminal = this.getTerminalPaymentElement().find(`option[value="${terminalName}"]`);

    let terminalID = $terminal.attr('data-term-id');

    $('#emv_payment_start').prop('disabled', _.isUndefined(terminalID));

    if ($terminal.length && $terminal.val() === 'USB') {
      // The USB Swipe option has been selected so open the old swipe UI
      if (isRefund) {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'credit_card' does not exist on type 'Mer... Remove this comment to see the full error message
        window.merchantos.register.credit_card.openCreditCardForRefund(null, false);
      } else {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'credit_card' does not exist on type 'Mer... Remove this comment to see the full error message
        window.merchantos.register.credit_card.open(null, false);
      }
    } else {
      if (!terminalID) {
        terminalID = '0';
      }

      const content_map = {
        form_name: 'register.set_terminal',
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        register_id: window.merchantos.session.getRegister().registerID,
        terminal_id: terminalID,
      };

      window.doServerCall(content_map, () => {});
    }
  };
}

window.merchantos.register.terminal_payment = new TerminalPayment();
